// ---------------------------------------------------------------------------
// Block Registry Bootstrap — imports and registers all block definitions in
// dependency order (parent blocks first, sub-kinds after parents are registered).
//
// Both server/ and ui/ import this once at startup.
// ---------------------------------------------------------------------------

import { blockRegistry } from "./index.js";

// ── Phase B: Simple blocks ──────────────────────────────────────────────
import { sectionHeaderDef } from "./definitions/section_header.js";
import { legendDef } from "./definitions/legend.js";
import { headingDef } from "./definitions/heading.js";
import { paragraphDef } from "./definitions/paragraph.js";
import { listDef as docListDef } from "./definitions/list.js";
import { imageDef } from "./definitions/image.js";
import { tableDef } from "./definitions/table.js";
import { sectionDef } from "./definitions/section.js";
import { headerChipsDef } from "./definitions/header_chips.js";

blockRegistry.register(sectionHeaderDef);
blockRegistry.register(legendDef);
blockRegistry.register(headingDef);
blockRegistry.register(paragraphDef);
blockRegistry.register(docListDef);
blockRegistry.register(imageDef);
blockRegistry.register(tableDef);
blockRegistry.register(sectionDef);
blockRegistry.register(headerChipsDef);

// ── Phase C: Data blocks ────────────────────────────────────────────────
import { textBlockDef } from "./definitions/text_block.js";
import { conditionalDef } from "./definitions/conditional.js";
import { tileRowDef } from "./definitions/tile_row.js";

blockRegistry.register(textBlockDef);
blockRegistry.register(conditionalDef);
blockRegistry.register(tileRowDef);

// ── Phase D: Complex blocks ─────────────────────────────────────────────
import { chartDef } from "./definitions/chart.js";
import { bulletListDef } from "./definitions/bullet_list.js";
import { mapDef } from "./definitions/map.js";
import { ganttDef } from "./definitions/gantt.js";

blockRegistry.register(chartDef);
blockRegistry.register(bulletListDef);
blockRegistry.register(mapDef);
blockRegistry.register(ganttDef);

// ── Phase E: Layout engine (flow) ──────────────────────────────────────
import { flowDef } from "./definitions/flow.js";

blockRegistry.register(flowDef);

// ── Phase F: Static layout blocks ──────────────────────────────────────
import { writeBoxDef } from "./definitions/write_box.js";
import { criteriaListDef } from "./definitions/criteria_list.js";

blockRegistry.register(writeBoxDef);
blockRegistry.register(criteriaListDef);

export { blockRegistry };
